import { P2GBox, P2GButton, P2GGrid, P2GIcon, P2GText, SvgWarningTriangle } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { P2GSidePanel } from '~/components/sidepanel';
import { TranslationNamespaces } from '~/lib/constants';
import { SuperButton } from './super-button';
import { useState } from 'react';
import { lazy, Suspense } from 'react';
import { ConcernType } from '../concerns/Concern';

const Concerns = lazy(() => import('../concerns/Concerns'));

interface ConcernSmartActionProps {
  descriptionKey: string;
  buttonKey: string;
  variantToUse?: 'primary' | 'secondary' | 'tertiary';
  limitToConcernTypes?: ConcernType[];
}

const ConcernsSmartAction = ({
  limitToConcernTypes,
  descriptionKey,
  buttonKey,
  variantToUse
}: ConcernSmartActionProps) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const [open, setOpen] = useState(false);

  return (
    <>
      <P2GGrid container alignItems="center" gap={2} wrap="nowrap">
        <P2GGrid item>
          <P2GIcon size="sm" palette="primary">
            <SvgWarningTriangle />
          </P2GIcon>
        </P2GGrid>
        <P2GGrid item flexGrow={1}>
          <P2GGrid container justifyContent="space-between" alignItems="center" spacing={1} wrap="nowrap">
            <P2GGrid item>
              <P2GText>
                <strong>{t(descriptionKey, 'Action needed on your account')}</strong>
              </P2GText>
            </P2GGrid>
            <P2GGrid item>
              <SuperButton onClick={() => setOpen(true)} variant={variantToUse}>
                {t(buttonKey, 'View')}
              </SuperButton>
            </P2GGrid>
          </P2GGrid>
        </P2GGrid>
      </P2GGrid>
      <P2GSidePanel title="Account Concerns" anchor="right" open={open} onClose={() => setOpen(false)}>
        {open && (
          <Suspense fallback={null}>
            <Concerns displayType="sidepanel" limit={limitToConcernTypes} onClick={() => setOpen(false)} />
            <P2GBox mt={4}>
              <P2GButton onClick={() => setOpen(false)}>{t('CLOSE_BUTTON', 'Close')}</P2GButton>
            </P2GBox>
          </Suspense>
        )}
      </P2GSidePanel>
    </>
  );
};

export default ConcernsSmartAction;
